<style lang="less" scoped>
.h5-about-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .flex-1 {
    flex: 1;
  }
  font-size: 12px;
}
.h5-content-div {
  margin: 16px;
  padding: 0 0 16px 0;
}
.topic-title {
  text-align: center;
  font-weight: 900;
  line-height: 32px;
}
.content-div {
  text-indent: 2em;
}
.line-topic-title {
  font-weight: 900;
  line-height: 30px;
  height: 30px;
}

.table-content-div{
  width: 100%;
  overflow-x: scroll;
}
.policy-table {
  width: 100%;
  border-collapse: collapse;
}
.policy-table tr {
  height: 32px;
  line-height: 32px;
}
.policy-table tr th {
  padding-left: 2px;
}
.policy-table tr td {
  padding-left: 2px;
}
.policy-a {
  text-decoration: underline;
  cursor: pointer;
  word-wrap:break-word;
  word-break: break-all;
}

.width-1{
  width: 20% !important;
}
</style>

<template>
  <div class="h5-about-container">
    <div class="h5-content-div">
      <div class="topic-title">隐私权政策</div>
      <div class="content-div">
        更新日期：2021年11月1日
      </div>
      <div class="content-div">
        生效日期：2021年11月2日
      </div>
      <div class="content-div">
        【无锡挚达物联科技有限公司】（以下简称“我们”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
      </div>
      <div class="content-div">
        请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私权政策》；阅读本声明的过程中，如果您不同意本声明或其中任何内容，您应立即停止使用平台服务。如果您使用平台服务的，即意味着您认可本声明全部内容。
      </div>
      <div class="line-topic-title">
        一、我们如何收集和使用您的个人信息
      </div>
      <div class="content-div">
        个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
      </div>
      <div class="content-div">
        我们仅会出于本政策所述的以下目的，收集和使用您的个人信息：
      </div>
      <div class="content-div">
        （一）帮助您成为我们的用户
      </div>
      <div class="content-div">
        您首先需要注册一个挚达APP账号成为挚达用户。当您注册时，您需要至少向我们提供您准备使用的注册手机号、密码、昵称，我们将通过发送短信验证码的方式来验证您的身份是否有效。
      </div>
      <div class="content-div">
        （二）向您提供产品/服务
      </div>
      <div class="line-topic-title">
        1、您向我们提供的个人信息
      </div>
      <div class="content-div">
        （1）支付：您在挚达APP上支付订单时，您可以选择第三方支付机构（如微信或支付宝支付等支付通道）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的挚达APP订单信息及对账信息与这些支付机构共享以确认您的支付指令并完成支付。
      </div>

      <div class="content-div">
        （2）客服：当您与我们的客服取得联系时，我们的系统可能会记录您与客服之间的通讯记录，以及使用您的账号信息以便核验身份；当您需要我们提供与您订单相关的客户服务时，我们可能会查询您的相关订单信息以便给予您适当的帮助和处理；当您需要客服协助您修改有关信息时，您可能还需要提供上述信息外的其他信息以便完成修改。
      </div>

      <div class="line-topic-title">
        2、我们在您使用服务过程中可能收集的个人信息
      </div>

      <div class="content-div">
        为了满足法律法规及提供服务的基本要求，保障您的账号安全与系统运行安全，我们会收集您在使用我们服务过程中产生的相关信息，包括：
      </div>
      <div class="content-div">
        （1）日志信息：当您使用我们提供的产品/服务时，我们会自动收集您使用我们服务的详细情况，并作为有关的网络日志保存，包括但不限于您的IP地址、浏览器的类型、使用的语言、操作系统的版本、访问的日期和时间、及您请求的网页记录以及设备相关信息（例如包括但不限于设备型号、名称、IMEI、设备MAC地址、软件安装列表、设备序列号、android ID）等信息或运行中的进程信息。
      </div>
      <div class="content-div">
        （2）照片信息：我们会根据您在软件使用过程中，需要更换头像的需求获取相机使用权限和SD卡读取权限，读取相机拍摄的照片或读取SD卡上您选择的照片，并保存。
      </div>
      <div class="content-div">
        （3）为使您能够使用和享受相应的服务及功能，我们会在挚达APP中嵌入第三方的SDK，我们审慎评估该等SDK的使用目的。有关SDK处理个人信息的目的、方式及范围等信息，请查看《第三方信息共享清单》
      </div>

      <div class="table-content-div">
        <table class="policy-table" border="1">
          <tr>
            <th width="10">
              SDK名称
            </th>
            <th  width="20">
              处理方式
            </th>
            <th  width="10">
              处理目的
            </th>
            <th  width="25">
              SDK收集的个人信息
            </th>
            <th  width="25">
              隐私政策协议链接
            </th>
            <th  width="20">
              公司
            </th>
          </tr>
          <tr>
            <td  width="10">
              友盟
            </td>
            <td  width="20">
              自动收集，且仅在启动 APP 用户同意隐私政策后收集
            </td>
            <td  width="10">
              推送消息
            </td>
            <td  width="25">
              设备版本、系统版本、生成ID、手机样式、手机名、iccid、bssid、MAC地址、IMSI、SIM卡信息、设备序列号、IMEI
            </td>
            <td  width="40"  class="policy-a">
              https://developer.umeng.com/docs/147377/detail/148509
            </td>
            <td  width="20">
             友盟同欣（北京）科技有限公司
            </td>
          </tr>
          <tr>
            <td  width="10">
              阿里云一键登录
            </td>
            <td  width="20">
              自动收集，且仅在启动 APP 用户同意隐私政策后收集
            </td>
            <td  width="10">
              本机号码一键登录
            </td>
            <td  width="25">
              网络信息、Mac地址、IMEI/IMSI、IP地址、手机号码、手机操作系统、硬件厂商
            </td>
            <td  width="40"  class="policy-a">
              http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=a2c4g.11186623.2.6.117a123eVzRrTd
            </td>
            <td  width="20">
             阿里巴巴集团控股有限公司
            </td>
          </tr>
          <tr>
            <td  width="10">
             腾讯移动开放平台（微信）
            </td>
            <td  width="20">
              自动收集，且仅在启动 APP 用户同意隐私政策后收集
            </td>
            <td  width="10">
              登录、分享、支付
            </td>
            <td  width="25">
             设备版本、系统版本、生成ID、手机样式、iccid、bssid、MAC地址、IMSI、IME
            </td>
            <td  width="40"  class="policy-a">
              https://support.weixin.qq.com/cgi-bin/mmsupportacctnodewebin/pages/RYiYJkLOrQwu0nb8
            </td>
            <td  width="20">
             深圳市腾讯计算机系统有限公司
            </td>
          </tr>
          <tr>
            <td  width="10">
             QQ 互联（腾讯开放平台）
            </td>
            <td  width="20">
              自动收集，且仅在启动 APP 用户同意隐私政策后收集
            </td>
            <td  width="10">
             为用户提供QQ三方登录功能，帮助用户分享内容至QQ
            </td>
            <td  width="25">
            设备标识符（Android如IMEI、Android ID、IMSI，iOS如IDFV）、MAC地址、IP地址、位置信息（如GPS）
            </td>
            <td  width="40"  class="policy-a">
              https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E
            </td>
            <td  width="20">
             深圳市腾讯计算机系统有限公司
            </td>
          </tr>
        </table>
      </div>


      <div class="content-div">
        对于从您使用相同桩到家账号登录各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。
      </div>
      <div class="content-div">
        （5）其他用途
      </div>
      <div class="content-div">
        我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
      </div>
      <div class="content-div">
        （6）请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：
      </div>
      <div class="content-div">
        1、与国家安全、国防安全有关的；
      </div>
      <div class="content-div">
        2、与公共安全、公共卫生、重大公共利益有关的；
      </div>
      <div class="content-div">
        3、与犯罪侦查、起诉、审判和判决执行等有关的；
      </div>
      <div class="content-div">
        4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      </div>
      <div class="content-div">
        5、所收集的个人信息是个人信息主体自行向社会公众公开的；
      </div>
      <div class="content-div">
        6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
      </div>
      <div class="content-div">
        7、根据您的要求签订合同所必需的；
      </div>
      <div class="content-div">
        8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
      </div>
      <div class="content-div">
        9、为合法的新闻报道所必需的；
      </div>
      <div class="content-div">
        10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
      </div>
      <div class="content-div">
        11、您在平台进行交易的有关数据，包括但不限于成交信息及评价等数据；及在使用平台服务时输入的关键字信息；
      </div>
      <div class="content-div">
        12、违反信用评价、违反法律规定或违反规则行为而对您采取的措施；
      </div>
      <div class="content-div">
        13、应法律法规要求需公示的企业名称等相关工商注册信息以及自然人经营者的信息；
      </div>
      <div class="content-div">
        14、法律法规规定的其他情形。
      </div>
      <div class="content-div">
        请注意，无法与任何特定个人直接建立联系的数据，不属于个人信息。如果我们将无法与任何特定个人建立联系的数据与其他信息结合用于识别自然人个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。
      </div>

      <div class="line-topic-title">
        二、我们如何使用 Cookie 和同类技术
      </div>
      <div class="content-div">
        Cookie的使用无锡挚达物联科技有限公司 “挚达APP”的在线服务、互动应用软件可能会使用 Cookie。此技术帮助我们更好地了解用户的行为,告诉我们用户浏览了我们平台的哪些部分,对网络搜索的效果并加以改善。我们将通过 Cookie收集的信息视为非个人信息。但是,如果法律将 Internet协议(IP)地址或类似识别标记视为个人信息,则我们亦将此等识别标记视为个人信息。同样,就本守则而言,在将非个人信息与个人信息结合使用的情况下,我们将结合使用的信息视为个人信息。 大多数Web浏览器会自动接受 Cookie,但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie。但请注意,禁用 Cookie后,将可能无法使用无锡挚达物联科技有限公司 “挚达APP”平台的某些功能。
      </div>
      <div class="line-topic-title">
        三、我们如何共享、转让、公开披露您的个人信息
      </div>
      <div class="line-topic-title">
        信息的用途
      </div>
      <div class="content-div">
        您授权无锡挚达物联科技有限公司 “挚达APP”出于以下用途使用您的个人信息:
      </div>
      <div class="content-div">
        a.向您提供无锡挚达物联科技有限公司 “挚达APP”的产品及服务,并进行无锡挚达物联科技有限公司 “挚达APP”相关网站及移动应用程序的管理和优化；
      </div>
      <div class="content-div">
        b.提升和改善无锡挚达物联科技有限公司 “挚达APP”现有产品及服务的功能和质量；
      </div>
      <div class="content-div">
        c.更新开展无锡挚达物联科技有限公司 “挚达APP”产品及服务相关的市场活动,向您推送最新的市场活动信息及优惠方案
      </div>
      <div class="content-div">
        d.设计、开发、推广全新的产品及服务；
      </div>
      <div class="content-div">
        e.协助行政机关、司法机构等有权机关开展调查,并遵守适用法律规则及向其他有权机关承诺之义；
      </div>
      <div class="content-div">
        在不透露您个人信息的前提下,无锡挚达物联科技有限公司 “挚达APP”有权对用户数据进行挖掘、分析和利用(包括商业化利用)。
      </div>
      <div class="line-topic-title">
        信息使用的说明
      </div>
      <div class="content-div">
       您授权我们在您使用无锡挚达物联科技有限公司 “挚达APP”产品及服务期间使用上述信息,若您注销帐号,我们将停止使用并根据您的要求删除您的个人信息。
      </div>
      <div class="content-div">
        a.与国家安全、国防安全有关的;
      </div>
      <div class="content-div">
        b.与公共安全、公共卫生、重大公共利益有关的;
      </div>
      <div class="content-div">
        c.与犯罪侦查、起诉、审判和判决执行等有关的;
      </div>
      <div class="content-div">
        d.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您同意的所收集的个人信息是您自行向社会公众开放的;
      </div>
      <div class="content-div">
        e.从合法公开披露的信息中收集个人信息的,如合法的新闻报道、政府信息公开等渠道;
      </div>
      <div class="content-div">
        f.根据您的要求实现产品功能及服务所必需的;用于维护所提供的产品和服务的安全和合规所必需的,例如发现、处置产品和服务的故障为合法的新闻报道所必需的学术研究机构基于公共利益开展统计或学术研究所必要,且对外提供学术研究或描述的结果时,对结果中所包含的个人信息进行去标识化处理的;
      </div>
      <div class="content-div">
        g.法律法规规定的其他情形。
      </div>
      <div class="line-topic-title">
        信息的共享
      </div>
      <div class="content-div">
        无锡挚达物联科技有限公司 “挚达APP”对您的个人信息承担保密义务,但您授权无锡挚达物联科技有限公司 “挚达APP”在下列情况下将您的信息与第三方共享：
      </div>
      <div class="content-div">
        a.为了提升无锡挚达物联科技有限公司 “挚达APP”的产品及服务质量或向您提供全新的产品及服务,上海挚达科技发展股份有限公司 “挚达APP”会在上海挚达科技发展股份有限公司 “挚达APP”汽车租赁有限公司、自营运营机构和第三方运营机构内部共享您的相关信息,也可能将上海挚达科技发展股份有限公司 “挚达APP”收集的信息提供给第三方用于分析和统计;
      </div>
      <div class="content-div">
        b.为了与第三方开展联合推广活动,上海挚达科技发展股份有限公司 “挚达APP”可能与其共享开展活动所必须的以及在活动过程中产生的相关信息；
      </div>
      <div class="content-div">
        c.为了维护您的合法权益,在协助处理与您有关的纠纷或争议时,上海挚达科技发展股份有限公司 “挚达APP”会向存在利害关系的第方提供解决纠纷或争议所必须的信息；
      </div>
      <div class="content-div">
        d.法律法规的规定及商业惯例,上海挚达科技发展股份有限公司 “挚达APP”需要接受第三方的审计或尽职调查时,可能向其提供您的相关信息；
      </div>
      <div class="content-div">
        e.其他经您同意或授权可以向第三方提供您的个人信息的情况。与我们共享您的个人信息的第三方可能包括以下类型:
      </div>
      <div class="content-div">
        与我们共享您的个人信息的第三方可能包括以下类型:
      </div>
      <div class="line-topic-title">
        软件服务提供商、智能设备提供商和系统服务提供商。
      </div>
      <div class="content-div">
        上海挚达科技发展股份有限公司 “挚达APP”与第三方软件、设备系统结合为您提供基于位置的服务时,可能会基于您对系统定位的授权及设定,收取您的位置信息及设备信息并提供给系统,特殊情境下会包含您另行填写的个人信息。
      </div>
      <div class="line-topic-title">
        供应商、服务提供商和其他合作伙伴。
      </div>
      <div class="content-div">
        我们可能将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴半,这些支持包括提供技术基础设施服务、提供产品内或产品链接后的功能型服务,分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务和调查。
      </div>
      <div class="line-topic-title">
        广告、分析服务类的授权合作伙伴。
      </div>
      <div class="content-div">
       未经您的授权,我们不会将您的个人信息与提供广告、分析服务的合作伙伴共享。
      </div>
      <div class="line-topic-title">
        金融、征信服务等其他合作伙伴。
      </div>
      <div class="content-div">
        根据您与相关合作伙伴签订的协议或文件,或基于法律法规、法律程序的要求或强制性的政府要求或司法裁定,或金融、征信审查等机构的合法需求,对您的个人信息进行综合统计、分析或加工等处理,并将数据结果分享给合作伙伴,用于判定您的资信状况,筛选优质用户或降低信贷坏账等。
      </div>
      <div class="line-topic-title">
        信息的转让与公开
      </div>
      <div class="content-div">
        我们不会将您的个人信息转让给除上海挚达科技发展股份有限公司 “挚达APP”及其关联公司外的公司、组织和个人或公开披露,但以下情况除外:
      </div>
      <div class="content-div">
        a.事先获得您的明确授权或同意；
      </div>
      <div class="content-div">
        b.根据法律法规、法律程序的要求或强制性的政府要求或司法裁定上海挚达科技发展股份有限公司 “挚达APP”必须提供;
      </div>
      <div class="content-div">
        c.符合您签署的其它法律文件(如本条款)的约定而使用；
      </div>
      <div class="content-div">
        d.在涉及合并、收购或破产清算时,如涉及到个人信息转让,我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束,否则我们会要求该公司、组织重新向您征求授权同意。
      </div>
      <div class="line-topic-title">
        四、我们如何保护您的个人信息
      </div>
      <div class="line-topic-title">
        信息的安全及保护措施
      </div>
      <div class="content-div">
        上海挚达科技发展股份有限公司 “挚达APP”采用以下措施保障会员的个人信息及上海挚达科技发展股份有限公司 “挚达APP”的安全:
      </div>
      <div class="content-div">
        上海挚达科技发展股份有限公司 “挚达APP”将采用严格的安全制度以及行业通行的安全技术和程序来确保您的个人信息不被丢失、泄露、损毁或滥用；
      </div>
      <div class="content-div">
        无锡挚达物联科技有限公司 “挚达APP”将采用行业通行的安全技术和程序,来保护您的个人信息不被未经授权的访问、使用;
      </div>
      <div class="content-div">
        无锡挚达物联科技有限公司 “挚达APP”的员工将受到保密协议的约束,同时还将受到数据信息的权限控制和操作监控；
      </div>
      <div class="content-div">
        但是,请您注意,任何安全系统都存在可能的及未知的风险。您访问的第三方网站经营者、您使用的第三方服务提供者和通过无锡挚达物联科技有限公司 “挚达APP”获取您的个人信息的第三方可能有自己的隐私保护规则以及获取您个人信息的方法和措施,这些第三方的隐私保护规则、获取个人信息的方法和措施将不会受到无锡挚达物联科技有限公司 “挚达APP”的控制。虽然无锡挚达物联科技有限公司 “挚达APP”将与可能接触到您的个人信息的无锡挚达物联科技有限公司 “挚达APP”的合作方等第三方签署保密协议并尽合理的努力督促其履行保密义务,但无锡挚达物联科技有限公司 “挚达APP”无法保证第三方一定会按照无锡挚达物联科技有限公司 “挚达APP”的要求采取保密措施,无锡挚达物联科技有限公司 “挚达APP”亦不对第三方的行为及后果承担任何责任。
      </div>
      <div class="content-div">
        作为用户,您可根据您的意愿决定是否使用无锡挚达物联科技有限公司 “挚达APP”的服务,是否主动提供个人信息。同时,您可以查看您提供给无锡挚达物联科技有限公司 “挚达APP”的个人信息及行程信息。如果您希望删除或更正您的个人信息,可以根据平台指示的步骤自行删除或更正,或拨打电话400-168-6826联系客服提供协助。
      </div>
      <div class="line-topic-title">
        五、您的权利
      </div>
      <div class="content-div">
        按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
      </div>
      <div class="line-topic-title">
        （一）访问您的个人信息
      </div>
      <div class="content-div">
        您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
      </div>
      <div class="content-div">
        账户信息——如果您希望访问或编辑您的账户中的个人资料信息和支付信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过app执行此类操作。
      </div>
      <div class="">
        搜索信息——您可以在app中访问或清除您的搜索历史记录、查看和修改兴趣以及管理其他数据。
      </div>
      <div class="content-div">
        如果您无法通过上述链接访问这些个人信息，您可以随时使用我们的 Web
        表单联系，或发送电子邮件至service@shzhida.com。我们将在30天内回复您的访问请求。
      </div>
      <div class="content-div">
        对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请发送电子邮件至【service@shzhida.com】。
      </div>
      <div class="content-div">
        当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过
      </div>
      <div class="line-topic-title">
        “（一）访问您的个人信息”中罗列的方式提出更正申请。
      </div>
      <div class="content-div">
        如果您无法通过上述链接更正这些个人信息，您可以随时使用我们的 Web
        表单联系，或发送电子邮件至service@shzhida.com。我们将在30天内回复您的更正请求。
      </div>
      <div class="line-topic-title">
        （二）删除您的个人信息
      </div>
      <div class="content-div">
        在以下情形中，您可以向我们提出删除个人信息的请求：
      </div>
      <div class="content-div">
        1、如果我们处理个人信息的行为违反法律法规；
      </div>
      <div class="content-div">
        2、如果我们收集、使用您的个人信息，却未征得您的同意；
      </div>
      <div class="content-div">
        3、如果我们处理个人信息的行为违反了与您的约定；
      </div>
      <div class="content-div">
        4、如果您不再使用我们的产品或服务，或您注销了账号；
      </div>
      <div class="content-div">
        5、如果我们不再为您提供产品或服务。
      </div>
      <div class="content-div">
        若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
      </div>
      <div class="content-div">
        当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
      </div>
      <div class="line-topic-title">
        （三）约束信息系统自动决策
      </div>
      <div class="content-div">
        在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。
      </div>
      <div class="line-topic-title">
        （四）响应您的上述请求
      </div>
      <div class="content-div">
        为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
      </div>
      <div class="content-div">
        我们将在三十天内做出答复。如您不满意，还可以通过以下途径投诉：拨打客服电话4006596580
      </div>
      <div class="content-div">
        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
      </div>
      <div class="content-div">
        在以下情形中，按照法律法规要求，我们将无法响应您的请求：
      </div>
      <div class="content-div">
        1、与国家安全、国防安全有关的；
      </div>
      <div class="content-div">
        2、与公共安全、公共卫生、重大公共利益有关的；
      </div>
      <div class="content-div">
        3、与犯罪侦查、起诉和审判等有关的；
      </div>
      <div class="content-div">
        4、有充分证据表明您存在主观恶意或滥用权利的；
      </div>
      <div class="content-div">
        5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
      </div>
      <div class="line-topic-title">
        六、您的个人信息如何在全球范围转移
      </div>
      <div class="content-div">
        原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。
      </div>
      <div class="content-div">
        此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。
      </div>
      <div class="line-topic-title">
        七、本隐私权政策如何更新
      </div>
      <div class="content-div">
        我们可能适时会对本隐私权政策进行调整或变更，本隐私权政策的任何更新将以标注更新时间的方式公布在我们网站上，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表您已充分阅读、理解并接受修改后的隐私权政策并受其约束。
      </div>
      <div class="line-topic-title">
        八、如何联系我们
      </div>
      <div class="content-div">
        如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：
      </div>
      <div class="content-div">
        邮箱：【 service@shzhida.com】；电话：【4006596580】
      </div>
      <div class="content-div">
        我们设立了个人信息保护专职部门（或个人信息保护专员），您可以通过以下方式与其联系：4006596580
      </div>
      <div class="">
        一般情况下，我们将在三十天内回复。
      </div>
      <div class="content-div">
        免责声明：以上建议仅供参考，不构成正式的法律意见，如您需要法律意见，请您根据您的实际业务场景咨询您外聘的律师或法律顾问。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    init() {},
  },
  mounted() {
    this.init()
  },
}
</script>
